// Company Health card (right rail). REAL: the V1 composite + its inputs
// (deriveCompanyHealthV1). PLACEHOLDER (mockData): Financial/Team/Data-Quality
// sub-dimensions + Revenue-Impact $, rendered muted with a MOCK title.
import React from "react";
import { useBrainResource } from "../lib/hooks";
import { deriveCompanyHealthV1 } from "../lib/metrics";
import { MOCK_HEALTH } from "../mock/mockData";

function d(r) { return r && r.status === "ok" ? r.data : null; }
function tone(v) { return v == null ? "text-slate-400" : v >= 80 ? "text-emerald-300" : v >= 60 ? "text-amber-300" : "text-rose-300"; }

export default function HealthCard() {
  const buHealth = useBrainResource("/bu/health");
  const schedulers = useBrainResource("/schedulers/health");
  const gaps = useBrainResource("/state/gaps");
  const outcomes = useBrainResource("/outcomes/summary");
  const queue = useBrainResource("/executive/queue", { params: { limit: 1 } });

  const health = deriveCompanyHealthV1({
    buHealth: d(buHealth), schedulers: d(schedulers), gaps: d(gaps),
    queueSummary: d(queue) ? d(queue).summary : null, outcomesSummary: d(outcomes),
  });

  return (
    <div data-testid="health-card" className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
      <div className="mb-2 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-200">Company Health</h3>
        <span className="rounded bg-slate-800 px-1.5 py-0.5 text-[10px] text-slate-400">V1</span>
      </div>
      <div className="flex items-end gap-2">
        <span className={`text-3xl font-extrabold ${tone(health.score)}`} data-testid="health-score">{health.score != null ? health.score : "—"}</span>
        <span className="pb-1 text-[11px] text-slate-500">{health.score != null ? `${health.countedKeys.length}/${health.subScores.length} real sub-scores` : "no real inputs"}</span>
      </div>

      {/* PLACEHOLDER sub-dimensions */}
      <div className="mt-3 space-y-1.5" title="MOCK placeholder — Financial/Team/Data-Quality have no backend yet">
        {MOCK_HEALTH.subdims.map((s) => (
          <div key={s.key} className="flex items-center gap-2">
            <span className="w-20 text-[11px] text-slate-500">{s.label}<span className="ml-0.5 text-[8px] align-super text-slate-600">*</span></span>
            <div className="h-1.5 flex-1 overflow-hidden rounded bg-slate-800"><div className={`h-full ${s.value >= 80 ? "bg-emerald-500/70" : "bg-amber-500/70"}`} style={{ width: `${s.value}%` }} /></div>
            <span className={`w-8 text-right text-[11px] ${tone(s.value)}`}>{s.value}</span>
          </div>
        ))}
      </div>
      <p className="mt-3 text-[11px] text-slate-500" title="MOCK placeholder — Revenue-Impact $ has no backend yet">
        Revenue impact <span className="text-slate-300">${MOCK_HEALTH.revenueImpact.toLocaleString()}</span><span className="ml-0.5 text-[8px] align-super text-slate-600">*</span>
      </p>
      <p className="mt-1 text-[9px] text-slate-600">* placeholder (mock)</p>
    </div>
  );
}
